import type { ReactNode } from "react";
import { tv } from "tailwind-variants";

const productCardMetaVariants = tv({
  base: "absolute px-5 py-3",
  variants: {
    position: {
      top: "top-0",
      "top-left": "top-0 left-0",
      "top-right": "top-0 right-0",
      bottom: "bottom-0",
      "bottom-left": "bottom-0 left-0",
      "bottom-right": "bottom-0 right-0",
    },
  },
  compoundVariants: [
    {
      position: ["top", "bottom"],
      className: "left-0 right-0 flex items-center justify-between",
    },
  ],
});

export default function ProductCardMeta({
  children,
  className,
  position = "bottom-right",
}: {
  children: ReactNode;
  className?: string;
  position?:
    | "top-left"
    | "top"
    | "top-right"
    | "bottom-left"
    | "bottom"
    | "bottom-right";
}) {
  return (
    <div className={productCardMetaVariants({ position, className })}>
      {children}
    </div>
  );
}

ProductCardMeta.displayName = "ProductCardMeta";
